import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/views/Main'
import Setting from '@/views/Setting'
import Login from '@/views/Login'
import DeviceType from '@/views/DeviceType'
import DeviceList from '@/views/DeviceList'
import CustomerList from '@/views/CustomerList'
import Operator from '@/views/Operator'
import Overview from '@/views/Overview'
import CustomerDevice from '@/views/CustomerDevice'
import OperatorDevice from '@/views/OperatorDevice'
import OperatorCustomer from '@/views/OperatorCustomer'

Vue.use(Router)

const router=new Router({
  routes: [
    {
      path: '/main',
      name: 'main',
      component: Main,
      meta:{
        title:'设备管理'
      },
      redirect:'/operator',
      children:[
        {
          path: '/customerDevice',
          name: 'customerDevice',
          component: CustomerDevice,
          meta:{
            title:'客户设备'
          }
        },
        {
          path: '/operatorDevice',
          name: 'operatorDevice',
          component: OperatorDevice,
          meta:{
            title:'运维设备'
          }
        },
        {
          path: '/operatorcustomer',
          name: 'operatorcustomer',
          component: OperatorCustomer,
          meta:{
            title:'运维客户'
          }
        },
        {
          path: '/operator',
          name: 'operator',
          component: Operator,
          meta:{
            title:'运维'
          }
        },
        {
          path: '/customer',
          name: 'customer',
          component: CustomerList,
          meta:{
            title:'用户'
          }
        },
        {
          path: '/device',
          name: 'device',
          component: DeviceList,
          meta:{
            title:'设备'
          }
        },
        {
          path: '/devicetype',
          name: 'devicetype',
          component: DeviceType,
          meta:{
            title:'设备型号'
          }
        },
        {
          path: '/setting',
          name: 'setting',
          component: Setting,
          meta:{
            title:'设置'
          }
        }
      ]
    },
    {
      path: '/',
      name: 'login',
      component: Login,
      meta:{
        title:'登录'
      }
    }
  ]
})
router.beforeEach((to,form,next)=>{
  	window.document.title=to.meta.title
    next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js